import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import {Tag} from '@/components/ui/tag'
import {ListEmptyState} from '@/components/section-card'
import type {SgsstAssessment} from '@/hooks/sgsst/evaluacion/use-sgsst'

export function PlanTarjetaVacia({title}: {title: string}) {
  return (
    <div className="surface mx-auto max-w-2xl">
      <ListEmptyState page title={title} />
    </div>
  )
}

export function PlanVacio({
  assessment,
  anyNoCumple,
  fase2,
  editable,
  proposalCount,
  propuestaHref,
  assessmentHref,
}: {
  assessment: SgsstAssessment | null | undefined
  anyNoCumple: boolean
  fase2: boolean
  editable: boolean
  proposalCount: number
  propuestaHref: string
  assessmentHref: string
}) {
  const {t} = useTranslation()
  const enlaceEvaluacion = (
    <Link to={assessmentHref} className="text-sm font-medium text-primary hover:underline">
      {t('plan.emptyCta')}
    </Link>
  )

  if (assessment && !anyNoCumple && fase2) {
    return (
      <div className="surface mx-auto max-w-2xl" data-testid="plan-sin-no-cumple">
        <ListEmptyState
          page
          title={t('plan.noNoCumpleTitle', {year: assessment.period_year})}
          action={<Tag tone="green">{t('plan.noNoCumpleTag')}</Tag>}
        />
      </div>
    )
  }

  return (
    <div className="surface mx-auto max-w-2xl">
      <ListEmptyState
        page
        title={t('plan.emptyTitle')}
        action={
          editable && fase2 && proposalCount > 0 && assessment ? (
            <div className="flex flex-col items-center gap-2">
              <Button asChild size="sm" data-testid="proponer-plan-empty-cta">
                <Link to={propuestaHref}>{t('plan.propuesta.cta', {year: assessment.period_year})}</Link>
              </Button>
              {enlaceEvaluacion}
            </div>
          ) : (
            <Button asChild size="sm">
              <Link to={assessmentHref}>{t('plan.emptyCta')}</Link>
            </Button>
          )
        }
      />
    </div>
  )
}
